// This file is automatically generated. Do not edit manually.

import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ShopOrderBatchActionApi {
	export async function releaseShopOrderBatch(args: { shopOrderBatchId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/releaseShopOrderBatch",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as void;
	}

	export async function releaseShopOrderBatches(args: { shopOrderBatchIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/releaseShopOrderBatches",
			method: "POST",
			data: {
				shopOrderBatchIds: args.shopOrderBatchIds,
			},
		});
		return response as void;
	}

	export async function revertBatchStateToPlanned(args: { shopOrderBatchId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/revertBatchStateToPlanned",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as void;
	}

	export async function revertBatchStateToInitial(args: { shopOrderBatchId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/revertBatchStateToInitial",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as void;
	}

	export async function cancelBatch(args: { shopOrderBatchId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/cancelBatch",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as void;
	}

	export async function releaseBatchShopOrderLinesWithEarmarkedAcquisition(args: {
		shopOrderBatchId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/releaseBatchShopOrderLinesWithEarmarkedAcquisition",
			method: "POST",
			data: {
				shopOrderBatchId: args.shopOrderBatchId,
			},
		});
		return response as void;
	}

	export async function startShopOrderBatchesUserWorkcenterOperations(args: {
		shopOrderBatchIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/startShopOrderBatchesUserWorkcenterOperations",
			method: "POST",
			data: {
				shopOrderBatchIds: args.shopOrderBatchIds,
			},
		});
		return response as void;
	}

	export async function revertStartShopOrderBatchesUserWorkcenterOperations(args: {
		shopOrderBatchIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/revertStartShopOrderBatchesUserWorkcenterOperations",
			method: "POST",
			data: {
				shopOrderBatchIds: args.shopOrderBatchIds,
			},
		});
		return response as void;
	}

	export async function completeShopOrderBatchesUserWorkcenterOperations(args: {
		shopOrderBatchIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/completeShopOrderBatchesUserWorkcenterOperations",
			method: "POST",
			data: {
				shopOrderBatchIds: args.shopOrderBatchIds,
			},
		});
		return response as void;
	}

	export async function changeProductionLineForShopOrderBatches(args: {
		shopOrderBatchIds: Array<number>;
		newProductionLineId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/production/shopOrderBatch/changeProductionLineForShopOrderBatches",
			method: "POST",
			data: {
				shopOrderBatchIds: args.shopOrderBatchIds,
				newProductionLineId: args.newProductionLineId,
			},
		});
		return response as void;
	}
}
